import ReactDOM from 'react-dom';

//component
import ListLayout from '@/components/page/Content/AppearanceTab/ListLayout';



const ListLayoutPortal = () => { 
    const targetContainer = document.getElementById('react-list-layout-container');
    let defaultSelectedType = targetContainer?.getAttribute?.('data-selected-list-layout') ?? ""

    if (!targetContainer) {
        return null;
    }
    
    return ReactDOM.createPortal(
      <ListLayout defaultSelectedType={defaultSelectedType} />, targetContainer
    );
}


export default ListLayoutPortal;